import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="9" height="10" viewBox="0 0 9 10" fill="none" {...props}><path opacity=".7" fillRule="evenodd" clipRule="evenodd" d="M4.5 8l-.34-.33-.34-.32L.34 3.98 0 3.65.68 3l.33.33L4.5 6.69l3.49-3.36.33-.33.68.65-.34.33-3.48 3.37-.34.32L4.5 8z" fill="#1F1F1F" /></svg>);